import { clx, Icon, icon } from "@hm/fundamental"

interface DatepickerTriggerProps {
	name?: string
	label: string
	displayValue: string
	isOpen: boolean
	disabled?: boolean
	triggerRef: React.RefObject<HTMLButtonElement>
	onToggle: () => void
	"data-cy": string
}

export const DatepickerTrigger: React.FC<DatepickerTriggerProps> = ({
	name,
	label,
	displayValue,
	isOpen,
	disabled,
	triggerRef,
	onToggle,
	"data-cy": dataCy,
}) => {
	return (
		<button
			ref={triggerRef}
			type="button"
			name={name}
			disabled={disabled}
			onClick={onToggle}
			className={clx(
				"flex items-center justify-between w-full h-12 rounded-lg border px-3 text-left",
				"border-border bg-container_background",
				"text-foreground",
				isOpen && "border-primary",
				disabled && "opacity-50 cursor-not-allowed",
			)}
			aria-expanded={isOpen}
			aria-haspopup="dialog"
			data-cy={dataCy}
		>
			<div className="flex flex-col justify-center min-w-0 flex-1">
				{displayValue ? (
					<>
						<span className="text-xs font-normal leading-4 text-foreground_faded">
							{label}
						</span>
						<span className="text-sm truncate">{displayValue}</span>
					</>
				) : (
					<span className="text-base font-medium leading-6 text-foreground_faded">
						{label}
					</span>
				)}
			</div>
			<Icon
				path={icon.mdiCalendar}
				size="regular"
				className="ml-2 shrink-0"
			/>
		</button>
	)
}
